import Button from "./Button";
import "./Modal.css";
import { ReactComponent as Dismiss } from "./static/icons/Dismiss-small.svg";

function Modal({ children, title, onClose }) {
  return (
    <div className="Modal-overlay" onClick={onClose}>
      <div className="Modal" onClick={(e) => e.stopPropagation()}>
        <div className="Title-row">
          <div>{title}</div>
          <Button
            id="modal-dismiss"
            variant="icon"
            onClick={onClose}
            icon={<Dismiss />}
          ></Button>
        </div>
        {children}
        <Button
          className="Modal-button"
          onClick={onClose}
          variant="supersimple"
          text="GOT IT, THANKS"
        ></Button>
      </div>
    </div>
  );
}

export default Modal;
